import React from "react";
import { useTranslation } from "react-i18next";

export default function Mfr(): JSX.Element {
    const { t } = useTranslation("assessment");
    return (
        <>
            <h3>{t("mfr.title") as string}</h3>
            <p>{t("mfr.paragraph-1") as string}</p>
            <br/>
            <h4>{t("mfr.sub-title-1") as string}</h4>
            <h5>{t("mfr.sub-sub-title") as string}</h5>
            <p>{t("mfr.paragraph-2") as string}</p>
            <p>{t("mfr.paragraph-3") as string}</p>
            <br/>
            <h4>{t("mfr.sub-title-2") as string}</h4>
            <p>{t("mfr.paragraph-4") as string}</p>
            <p>{t("mfr.paragraph-5") as string}<a className="bolder-text" href={t("mfr.hyperlink") as string} target='_blank' rel="noopener noreferrer">{t("mfr.hyperlink-text") as string}</a>.</p>           
        </>
    );
}